import React, { useEffect, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import FormStepper from 'components/base/form-stepper';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { useNavigate } from 'react-router-dom';
import { AddInternalProcurementType } from 'models/procurement.model';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import ExcessReturnsPreview from './excess-returns-preview';
import ExcessReturnsForm from './excess-returns-form';
import useKitchenInventoryStockContext from 'contexts/kitchen/inventory-stock.context/context';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

export const vendorOptions = [
  { id: '1', name: 'Femite food ltd', price: 'N 1,700/gram' },
  { id: '2', name: 'Femite food ltd', price: 'N 1,700/gram' },
  { id: '3', name: 'Femite food ltd', price: 'N 1,700/gram' },
  { id: '4', name: 'Femite food ltd', price: 'N 1,700/gram' }
];

const initialExcessReturn = {
  ingredient_id: '',
  ingredient_name: '',
  unit_type: '',
  quantity: ''
};

const InventoryStockExcessReturns = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const { setIsBackLink, setBackLinkTitle, activeStore } = useDashboardContext();
  const { can } = useRoleContext();
  const canWriteInventoryManagement = can(
    InventoryModule.InventoryManagement,
    RolePermission.Write
  );
  const { stocksToEdit } = useKitchenInventoryStockContext();
  const [formData, setFormData] = useState<AddInternalProcurementType[]>(
    stocksToEdit.map((stockToEdit) => ({
      ingredient_id: stockToEdit.ingredient_id,
      ingredient_name: stockToEdit.ingredient.name,
      quantity: '',
      unit_type: stockToEdit.ingredient.unit_type
    })) || [initialExcessReturn]
  );
  const [isCreatingExcessReturn, setIsCreatingExcessReturn] = useState(false);
  const router = useNavigate();

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to procurement');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  const setValue = (index: number, field: keyof AddInternalProcurementType, value: string) => {
    setFormData((prev) =>
      prev.map((data, i) => (i === index ? { ...data, [field]: value } : data))
    );
  };

  const addForm = () => setFormData([...formData, { ...initialExcessReturn }]);

  const removeItem = (index: number) => setFormData(formData.filter((data, i) => i !== index));

  function isFormFilled(data: AddInternalProcurementType[]): boolean {
    for (const item of data) {
      for (const key in item) {
        if (
          typeof item[key as keyof AddInternalProcurementType] === 'string' &&
          item[key as keyof AddInternalProcurementType] === ''
        ) {
          return false;
        }
      }
    }
    return true;
  }

  const data = {
    note: '.',
    items: formData.map((request) => {
      return {
        ingredient_id: request.ingredient_id,
        quantity: Number(request.quantity)
      };
    })
  };

  const createExcessReturns = async () => {
    if (!canWriteInventoryManagement) return;
    if (!activeStore?.id) return;
    try {
      setIsCreatingExcessReturn(true);
      const response = await apiService.post(
        `kitchen-store/stores/${activeStore.id}/initiate-return`,
        {
          data
        }
      );
      if (response) {
        router(MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK);
        toast(<ToastMessage message='Excess returns created successfully' type='success' />);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error creating excess returns'}
          type='error'
        />
      );
    } finally {
      setIsCreatingExcessReturn(false);
    }
  };

  const handleEdit = () => setStep(1);
  return (
    <div className='ml-2 md:ml-8'>
      <h4 className='text-[24px] font-semibold text-[#2E3031]'>Excess returns</h4>
      <p className='text-[#6F7376] text-sm mb-8'>Need to return items to the main store?</p>
      <div className=' w-full max-w-[678px]'>
        <FormStepper
          disabled={
            step === 1
              ? !isFormFilled(formData) || !canWriteInventoryManagement
              : !canWriteInventoryManagement
          }
          step={step}
          title={step === 1 ? 'Items to return' : 'Review items to return'}
          subtitle={step === 2 ? 'Ensure you have all items you want to return' : ''}
          setStep={setStep}
          handleConfirmClick={() => {
            createExcessReturns();
          }}
          loading={isCreatingExcessReturn}
          handleCancelClick={() => {
            navigate(-1);
          }}>
          {step === 1 ? (
            <div>
              {formData.map((data, index) => (
                <ExcessReturnsForm
                  key={index}
                  data={data}
                  index={index}
                  setValue={setValue}
                  removeItem={removeItem}
                />
              ))}
              {canWriteInventoryManagement && (
                <button onClick={addForm} className='text-[#0080E5] mt-2 font-medium text-sm'>
                  + Add Item
                </button>
              )}
            </div>
          ) : (
            <div>
              <ExcessReturnsPreview formData={formData} handleEdit={handleEdit} />
            </div>
          )}
        </FormStepper>
      </div>
    </div>
  );
};

export default InventoryStockExcessReturns;
